/**
 * Represents the zeus.apollon_fk_conf.conf.kontakte value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, Model, type MutationsObject } from '@kp/js-model';
import { Dokument } from '@/models/apollon_conf_fk/Dokument';

export class DokumenteConfig extends Model {
    public docs: Dokument[] | null = null;
    public infotext: string | null = null;
    public label: string | null = null;
    
    public mutations(): MutationsObject {
        return {
            docs: (val: Dokument[]) => val ? val.map((e) => createModel(Dokument, e)) : [],
        };
    }
}